module.exports = __webpack_public_path__ + "img/demand.6b13b048.svg";